.issue-summary-container {
  --size-issue-latter: 16px;

  display: flex;
  align-items: center;
  gap: 4px;
}

.count {
  color: var(--neutral-10-color);
  margin-right: 10px;

  &.fix-width {
    width: 27px;
  }
}

.tag {
  width: var(--size-issue-latter);
  height: var(--size-issue-latter);
  min-width: var(--size-issue-latter);
  min-height: var(--size-issue-latter);
  line-height: var(--size-issue-latter);
  font-size: var(--sm-font-size);
}
